import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Control } from 'shared/components/fields/control';
import { TextInputWrapper } from 'shared/components/fields/text';
import { DHWControlType } from 'console/climatic/utils/dhw-control-type';
import { MaterialBoolControl, MaterialDropdown } from 'shared/components/fields';
import { useEditingProps } from 'z3k-settings/components/utils/unpack-props';
import { useCallback, useContext, useMemo } from 'react';
import { removeNulls } from 'utils';
import { ControlWithoutValidation } from 'shared/components/fields/control/without-validation';
import { findBoilerAdapterBySlot } from 'z3k-parser/lib';
import { BoilerAdapter, HeatingCircuit } from 'z3k-config';
import { dhw_boiler_pump_id, dhw_temp_sensor_id } from 'console/climatic/constants';
import { Z3KSettingsEditor } from 'z3k-settings/provider/types';
export function DhwCard({ dhw_settings }) {
    const { config, replace_config } = useContext(Z3KSettingsEditor);
    const boiler_control_type_options = useMemo(() => removeNulls([
        { text: 'Отключен', value: DHWControlType.OFF },
        { text: 'Бойлер', value: DHWControlType.BOILER },
        dhw_settings.has_adapter_on_slot_1
            ? {
                text: 'Двухконтурный',
                value: DHWControlType.FLOW_DHW,
            }
            : null,
        dhw_settings.has_adapter_on_slot_1
            ? {
                text: 'Котёл + бойлер',
                value: DHWControlType.BOILER_PLUS_DHW_BOILER,
            }
            : null,
    ]), [dhw_settings.has_adapter_on_slot_1]);
    const type_field = useCallback((input_props) => (_jsx(MaterialDropdown, { options: boiler_control_type_options, ...input_props })), [boiler_control_type_options]);
    const nameEditingProps = useEditingProps(dhw_settings.id, 'heating_circuits', 'name');
    const onTypeChange = (new_value) => {
        const adapter = findBoilerAdapterBySlot(config, 1);
        if (adapter != null) {
            //Если не двухконтурный или не котел + бойлер,
            // то надо выключить second_channel
            replace_config(BoilerAdapter.get.modifyById(config, adapter.id, (b_adapter) => BoilerAdapter.setSecondChannel(b_adapter, dhw_settings.control_type === DHWControlType.OFF ||
                dhw_settings.control_type === DHWControlType.BOILER
                ? false
                : dhw_settings.boiler_second_channel)));
        }
        replace_config(HeatingCircuit.get.modifyById(config, dhw_settings.id, (circuit) => {
            switch (new_value) {
                case DHWControlType.OFF:
                    return {
                        ...HeatingCircuit.setEnabled(HeatingCircuit.setFlowDHW(circuit, false), false),
                        name: dhw_settings.name,
                        water_temp_sensor: null,
                        dhw_temp_sensor: null,
                        control_devices: [],
                    };
                case DHWControlType.BOILER:
                    return {
                        ...HeatingCircuit.setEnabled(HeatingCircuit.setFlowDHW(circuit, false), true),
                        name: dhw_settings.name,
                        water_temp_sensor: null,
                        dhw_temp_sensor: dhw_temp_sensor_id,
                        control_devices: [dhw_boiler_pump_id],
                    };
                case DHWControlType.FLOW_DHW: {
                    const adapter = findBoilerAdapterBySlot(config, 1);
                    return {
                        ...HeatingCircuit.setEnabled(HeatingCircuit.setFlowDHW(circuit, true), true),
                        name: dhw_settings.name,
                        water_temp_sensor: null,
                        dhw_temp_sensor: adapter.id,
                        control_devices: [adapter.id],
                    };
                }
                case DHWControlType.BOILER_PLUS_DHW_BOILER: {
                    const adapter = findBoilerAdapterBySlot(config, 1);
                    return {
                        ...HeatingCircuit.setEnabled(HeatingCircuit.setFlowDHW(circuit, false), true),
                        name: dhw_settings.name,
                        water_temp_sensor: null,
                        dhw_temp_sensor: adapter.id,
                        control_devices: [adapter.id],
                    };
                }
            }
        }));
    };
    return (_jsxs(_Fragment, { children: [_jsx(Control, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", ...nameEditingProps, field: TextInputWrapper, help_id: null }), _jsx(ControlWithoutValidation, { label: "\u0422\u0438\u043F", value: dhw_settings.control_type, onChange: onTypeChange, field: type_field, help_id: null }), (dhw_settings.control_type === DHWControlType.BOILER_PLUS_DHW_BOILER ||
                dhw_settings.control_type === DHWControlType.FLOW_DHW) && (_jsx(MaterialBoolControl, { color: "primary", label: "\u0412\u0442\u043E\u0440\u043E\u0439 \u043A\u043E\u043D\u0442\u0443\u0440", value: dhw_settings.boiler_second_channel, onChange: (check) => {
                    const adapter = findBoilerAdapterBySlot(config, 1);
                    if (adapter != null) {
                        //Если не двухконтурный или не котел + бойлер,
                        // то надо выключить second_channel
                        replace_config(BoilerAdapter.get.modifyById(config, adapter.id, (b_adapter) => BoilerAdapter.setSecondChannel(b_adapter, check)));
                    }
                } }))] }));
}
